import { render, staticRenderFns } from "./form-section-starter.vue?vue&type=template&id=2ec6d334&scoped=true&"
import script from "./form-section-starter.vue?vue&type=script&lang=ts&"
export * from "./form-section-starter.vue?vue&type=script&lang=ts&"
import style0 from "./form-section-starter.vue?vue&type=style&index=0&id=2ec6d334&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec6d334",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VVirtualScroll } from 'vuetify/lib/components/VVirtualScroll';
installComponents(component, {VCol,VRow,VVirtualScroll})
